import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/admin/person-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-d920599a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = {
  key: 1,
  class: "flex justify-center mt-10"
}
const _hoisted_3 = { class: "navigation flex pb-6 w-full justify-start gap-4" }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "inline-flex flex-row border border-[#EAECF0] bg-[#F9FAFB] p-1 rounded-full gap-1 mb-8" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 3,
  class: "mt-14"
}
const _hoisted_9 = { class: "rounded-xl bg-white border border-[#EAECF0]" }
const _hoisted_10 = { class: "text-2xl text-[#101828] font-semibold p-6 border-b border-b-2 border-[#EAECF0]" }
const _hoisted_11 = { class: "min-w-full w-full upload-preview-table" }
const _hoisted_12 = { class: "columns" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "text-start text-xs text-[#475467] font-medium py-3" }, null, -1))
const _hoisted_14 = { class: "text-start text-xs text-[#475467] font-medium py-3" }
const _hoisted_15 = { class: "text-start text-xs text-[#475467] font-medium py-3" }
const _hoisted_16 = { class: "text-start text-xs text-[#475467] font-medium py-3" }
const _hoisted_17 = { class: "text-start text-xs text-[#475467] font-medium py-3" }
const _hoisted_18 = { class: "text-start text-xs text-[#475467] font-medium py-3" }
const _hoisted_19 = { class: "text-start text-xs text-[#475467] font-medium py-3" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "pl-2 py-6" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Person Icon"
  })
], -1))
const _hoisted_21 = { class: "text-sm text-[#475467] py-6" }
const _hoisted_22 = { class: "text-sm text-[#475467] py-6" }
const _hoisted_23 = { class: "text-sm text-[#475467] py-6" }
const _hoisted_24 = { class: "text-sm text-[#475467] py-6" }
const _hoisted_25 = { class: "text-sm text-[#475467] py-6" }
const _hoisted_26 = { class: "text-sm text-[#475467] py-6" }
const _hoisted_27 = { class: "flex items-center justify-between w-full pt-8" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "13",
  height: "12",
  viewBox: "0 0 13 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "me-2.5"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 6L5.75 1.25M1 6L5.75 10.75M1 6L12.0833 6",
    stroke: "#344054",
    "stroke-width": "1.58333",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_29 = { class: "flex items-center" }
const _hoisted_30 = {
  key: 0,
  class: "inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-e-transparent align-[-0.125em] text-surface motion-reduce:animate-[spin_1.5s_linear_infinite] dark:text-white me-2",
  role: "status"
}
const _hoisted_31 = { key: 0 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1))
const _hoisted_33 = { class: "fixed inset-0 z-10 w-screen overflow-y-auto" }
const _hoisted_34 = { class: "flex min-h-full items-end justify-center p-8 text-center sm:items-center" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18 6L6 18M6 6L18 18",
    stroke: "#98A2B3",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-auto flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
      fill: "#FEE4E2"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M24 20V24M24 28H24.01M34 24C34 29.5228 29.5228 34 24 34C18.4772 34 14 29.5228 14 24C14 18.4772 18.4772 14 24 14C29.5228 14 34 18.4772 34 24Z",
      stroke: "#D92D20",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1))
const _hoisted_38 = { class: "mt-6 text-center" }
const _hoisted_39 = { class: "font-normal text-sm text-[#475467] text-center mt-2" }
const _hoisted_40 = { class: "flex justify-around items-center" }
const _hoisted_41 = { key: 4 }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1))
const _hoisted_43 = { class: "fixed inset-0 z-10 w-screen overflow-y-auto" }
const _hoisted_44 = { class: "flex min-h-full items-end justify-center p-8 text-center sm:items-center" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "13",
  height: "13",
  viewBox: "0 0 13 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.587 9.72511C10.7015 9.83959 10.7658 9.99486 10.7658 10.1568C10.7658 10.3187 10.7015 10.4739 10.587 10.5884C10.4725 10.7029 10.3173 10.7672 10.1554 10.7672C9.99346 10.7672 9.83819 10.7029 9.72371 10.5884L6.49961 7.36328L3.27449 10.5874C3.16002 10.7019 3.00475 10.7662 2.84285 10.7662C2.68096 10.7662 2.52569 10.7019 2.41121 10.5874C2.29674 10.4729 2.23242 10.3176 2.23242 10.1557C2.23242 9.99384 2.29674 9.83858 2.41121 9.7241L5.63633 6.5L2.41223 3.27488C2.29775 3.1604 2.23344 3.00514 2.23344 2.84324C2.23344 2.68134 2.29775 2.52608 2.41223 2.4116C2.52671 2.29712 2.68197 2.23281 2.84387 2.23281C3.00577 2.23281 3.16103 2.29712 3.27551 2.4116L6.49961 5.63672L9.72473 2.41109C9.83921 2.29661 9.99447 2.2323 10.1564 2.2323C10.3183 2.2323 10.4735 2.29661 10.588 2.41109C10.7025 2.52557 10.7668 2.68084 10.7668 2.84273C10.7668 3.00463 10.7025 3.15989 10.588 3.27437L7.36289 6.5L10.587 9.72511Z",
    fill: "#828284"
  })
], -1))
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-auto flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "78",
    height: "77",
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      x: "0.9375",
      width: "76.125",
      height: "76.125",
      rx: "38.0625",
      fill: "#53DDC9",
      "fill-opacity": "0.25"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M59.9167 25H33.375C31.1292 25 29.2917 26.8375 29.2917 29.0833V47.4583C29.2917 48.5413 29.7219 49.5799 30.4876 50.3457C31.2534 51.1115 32.292 51.5417 33.375 51.5417H59.9167C62.1829 51.5417 64 49.7246 64 47.4583V29.0833C64 28.0004 63.5698 26.9618 62.804 26.196C62.0382 25.4302 60.9996 25 59.9167 25ZM59.9167 47.4583H33.375V32.4929L46.6458 39.2917L59.9167 32.4929V47.4583ZM46.6458 35.8413L33.375 29.0833H59.9167L46.6458 35.8413ZM25.2083 47.4583C25.2083 47.8054 25.2696 48.1321 25.3104 48.4792H17.0417C15.9147 48.4792 15 47.5604 15 46.4375C15 45.3146 15.9147 44.3958 17.0417 44.3958H25.2083V47.4583ZM21.125 28.0625H25.3104C25.2696 28.4096 25.2083 28.7362 25.2083 29.0833V32.1458H21.125C20.0021 32.1458 19.0833 31.2271 19.0833 30.1042C19.0833 28.9812 20.0021 28.0625 21.125 28.0625ZM17.0417 38.2708C17.0417 37.1479 17.9604 36.2292 19.0833 36.2292H25.2083V40.3125H19.0833C17.9604 40.3125 17.0417 39.3937 17.0417 38.2708Z",
      fill: "#53DDC9"
    })
  ])
], -1))
const _hoisted_48 = { class: "mt-6 text-center" }
const _hoisted_49 = { class: "text-center" }
const _hoisted_50 = { class: "text-sm text-[#9CA3AF] mb-4" }
const _hoisted_51 = { class: "text-[#6A737F]" }
const _hoisted_52 = { class: "mt-6 flex justify-around items-center flex-col" }
const _hoisted_53 = {
  type: "button",
  class: "px-8 py-2 text-base mt-3 flex flex-row justify-evenly items-center flex-wrap w-full"
}
const _hoisted_54 = { class: "text-[#6A737F]" }
const _hoisted_55 = { class: "text-[#8777FF]" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1))
const _hoisted_57 = { class: "fixed inset-0 z-10 w-screen overflow-y-auto" }
const _hoisted_58 = { class: "flex min-h-full items-end justify-center p-8 text-center sm:items-center" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "13",
  height: "13",
  viewBox: "0 0 13 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.587 9.72511C10.7015 9.83959 10.7658 9.99486 10.7658 10.1568C10.7658 10.3187 10.7015 10.4739 10.587 10.5884C10.4725 10.7029 10.3173 10.7672 10.1554 10.7672C9.99346 10.7672 9.83819 10.7029 9.72371 10.5884L6.49961 7.36328L3.27449 10.5874C3.16002 10.7019 3.00475 10.7662 2.84285 10.7662C2.68096 10.7662 2.52569 10.7019 2.41121 10.5874C2.29674 10.4729 2.23242 10.3176 2.23242 10.1557C2.23242 9.99384 2.29674 9.83858 2.41121 9.7241L5.63633 6.5L2.41223 3.27488C2.29775 3.1604 2.23344 3.00514 2.23344 2.84324C2.23344 2.68134 2.29775 2.52608 2.41223 2.4116C2.52671 2.29712 2.68197 2.23281 2.84387 2.23281C3.00577 2.23281 3.16103 2.29712 3.27551 2.4116L6.49961 5.63672L9.72473 2.41109C9.83921 2.29661 9.99447 2.2323 10.1564 2.2323C10.3183 2.2323 10.4735 2.29661 10.588 2.41109C10.7025 2.52557 10.7668 2.68084 10.7668 2.84273C10.7668 3.00463 10.7025 3.15989 10.588 3.27437L7.36289 6.5L10.587 9.72511Z",
    fill: "#828284"
  })
], -1))
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-auto flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "78",
    height: "77",
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      x: "0.9375",
      width: "76.125",
      height: "76.125",
      rx: "38.0625",
      fill: "#E2DFFF"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M24.7504 33.0499C26.3152 33.0499 27.8159 32.4283 28.9223 31.3219C30.0288 30.2154 30.6504 28.7147 30.6504 27.1499C30.6504 25.5851 30.0288 24.0845 28.9223 22.978C27.8159 21.8715 26.3152 21.2499 24.7504 21.2499C23.1856 21.2499 21.6849 21.8715 20.5785 22.978C19.472 24.0845 18.8504 25.5851 18.8504 27.1499C18.8504 28.7147 19.472 30.2154 20.5785 31.3219C21.6849 32.4283 23.1856 33.0499 24.7504 33.0499ZM24.7504 35.9999C25.9126 35.9999 27.0634 35.771 28.1371 35.3263C29.2109 34.8815 30.1865 34.2296 31.0083 33.4078C31.8301 32.586 32.482 31.6104 32.9267 30.5367C33.3715 29.4629 33.6004 28.3121 33.6004 27.1499C33.6004 25.9877 33.3715 24.8369 32.9267 23.7632C32.482 22.6894 31.8301 21.7138 31.0083 20.892C30.1865 20.0702 29.2109 19.4183 28.1371 18.9736C27.0634 18.5288 25.9126 18.2999 24.7504 18.2999C22.4032 18.2999 20.1522 19.2323 18.4925 20.892C16.8328 22.5517 15.9004 24.8028 15.9004 27.1499C15.9004 29.4971 16.8328 31.7481 18.4925 33.4078C20.1522 35.0675 22.4032 35.9999 24.7504 35.9999Z",
      fill: "#8777FF"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M21.3701 32.7431C21.5074 32.8802 21.6164 33.0429 21.6908 33.2221C21.7651 33.4013 21.8034 33.5934 21.8034 33.7874C21.8034 33.9815 21.7651 34.1736 21.6908 34.3528C21.6164 34.532 21.5074 34.6947 21.3701 34.8317L20.373 35.8259C18.4541 37.7453 17.376 40.3482 17.3758 43.0622V48.5374C17.3758 48.9286 17.2204 49.3038 16.9438 49.5804C16.6671 49.857 16.292 50.0124 15.9008 50.0124C15.5096 50.0124 15.1344 49.857 14.8578 49.5804C14.5812 49.3038 14.4258 48.9286 14.4258 48.5374V43.0622C14.4262 39.5658 15.8152 36.2127 18.2873 33.7402L19.2815 32.7431C19.4185 32.6058 19.5813 32.4968 19.7605 32.4224C19.9397 32.3481 20.1318 32.3098 20.3258 32.3098C20.5198 32.3098 20.7119 32.3481 20.8911 32.4224C21.0703 32.4968 21.2331 32.6058 21.3701 32.7431ZM56.1565 31.8581C56.0191 31.9952 55.9101 32.1579 55.8358 32.3371C55.7614 32.5163 55.7231 32.7084 55.7231 32.9024C55.7231 33.0965 55.7614 33.2886 55.8358 33.4678C55.9101 33.647 56.0191 33.8097 56.1565 33.9467L57.1536 34.9409C58.1038 35.8912 58.8576 37.0194 59.3719 38.261C59.8861 39.5026 60.1508 40.8333 60.1508 42.1772V48.5374C60.1508 48.9286 60.3062 49.3038 60.5828 49.5804C60.8594 49.857 61.2346 50.0124 61.6258 50.0124C62.017 50.0124 62.3922 49.857 62.6688 49.5804C62.9454 49.3038 63.1008 48.9286 63.1008 48.5374V42.1772C63.1004 38.6808 61.7114 35.3277 59.2392 32.8552L58.2451 31.8581C58.1081 31.7208 57.9453 31.6118 57.7661 31.5374C57.5869 31.4631 57.3948 31.4248 57.2008 31.4248C57.0068 31.4248 56.8147 31.4631 56.6355 31.5374C56.4563 31.6118 56.2935 31.7208 56.1565 31.8581Z",
      fill: "#8777FF"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M51.3002 33.0499C49.7354 33.0499 48.2347 32.4283 47.1283 31.3219C46.0218 30.2154 45.4002 28.7147 45.4002 27.1499C45.4002 25.5851 46.0218 24.0845 47.1283 22.978C48.2347 21.8715 49.7354 21.2499 51.3002 21.2499C52.865 21.2499 54.3657 21.8715 55.4721 22.978C56.5786 24.0845 57.2002 25.5851 57.2002 27.1499C57.2002 28.7147 56.5786 30.2154 55.4721 31.3219C54.3657 32.4283 52.865 33.0499 51.3002 33.0499ZM51.3002 35.9999C50.138 35.9999 48.9872 35.771 47.9134 35.3263C46.8397 34.8815 45.8641 34.2296 45.0423 33.4078C44.2205 32.586 43.5686 31.6104 43.1239 30.5367C42.6791 29.4629 42.4502 28.3121 42.4502 27.1499C42.4502 25.9877 42.6791 24.8369 43.1239 23.7632C43.5686 22.6894 44.2205 21.7138 45.0423 20.892C45.8641 20.0702 46.8397 19.4183 47.9134 18.9736C48.9872 18.5288 50.138 18.2999 51.3002 18.2999C53.6474 18.2999 55.8984 19.2323 57.5581 20.892C59.2178 22.5517 60.1502 24.8028 60.1502 27.1499C60.1502 29.4971 59.2178 31.7481 57.5581 33.4078C55.8984 35.0675 53.6474 35.9999 51.3002 35.9999ZM38.0252 45.5874C36.0692 45.5874 34.1934 46.3644 32.8103 47.7475C31.4272 49.1306 30.6502 51.0065 30.6502 52.9624V56.7974C30.6502 57.1886 30.4948 57.5638 30.2182 57.8404C29.9416 58.117 29.5664 58.2724 29.1752 58.2724C28.784 58.2724 28.4088 58.117 28.1322 57.8404C27.8556 57.5638 27.7002 57.1886 27.7002 56.7974V52.9624C27.7002 50.2241 28.788 47.5979 30.7243 45.6615C32.6606 43.7252 35.2868 42.6374 38.0252 42.6374C40.7636 42.6374 43.3898 43.7252 45.3261 45.6615C47.2624 47.5979 48.3502 50.2241 48.3502 52.9624V56.7974C48.3502 57.1886 48.1948 57.5638 47.9182 57.8404C47.6416 58.117 47.2664 58.2724 46.8752 58.2724C46.484 58.2724 46.1088 58.117 45.8322 57.8404C45.5556 57.5638 45.4002 57.1886 45.4002 56.7974V52.9624C45.4002 51.9939 45.2094 51.0349 44.8388 50.1401C44.4682 49.2454 43.9249 48.4323 43.2401 47.7475C42.5553 47.0627 41.7423 46.5194 40.8475 46.1488C39.9527 45.7782 38.9937 45.5874 38.0252 45.5874Z",
      fill: "#8777FF"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M38.0258 41.1625C39.5906 41.1625 41.0912 40.5409 42.1977 39.4344C43.3042 38.3279 43.9258 36.8273 43.9258 35.2625C43.9258 33.6977 43.3042 32.197 42.1977 31.0905C41.0912 29.9841 39.5906 29.3625 38.0258 29.3625C36.461 29.3625 34.9603 29.9841 33.8539 31.0905C32.7474 32.197 32.1258 33.6977 32.1258 35.2625C32.1258 36.8273 32.7474 38.3279 33.8539 39.4344C34.9603 40.5409 36.461 41.1625 38.0258 41.1625ZM38.0258 44.1125C40.3729 44.1125 42.624 43.1801 44.2837 41.5204C45.9434 39.8607 46.8758 37.6096 46.8758 35.2625C46.8758 32.9153 45.9434 30.6643 44.2837 29.0046C42.624 27.3449 40.3729 26.4125 38.0258 26.4125C35.6786 26.4125 33.4276 27.3449 31.7679 29.0046C30.1082 30.6643 29.1758 32.9153 29.1758 35.2625C29.1758 37.6096 30.1082 39.8607 31.7679 41.5204C33.4276 43.1801 35.6786 44.1125 38.0258 44.1125Z",
      fill: "#8777FF"
    })
  ])
], -1))
const _hoisted_62 = { class: "mt-6 text-center" }
const _hoisted_63 = { class: "mt-4 text-center" }
const _hoisted_64 = { class: "text-sm text-[#9CA3AF] mb-4" }
const _hoisted_65 = { class: "text-[#6A737F]" }
const _hoisted_66 = { class: "mt-6 flex justify-around items-center flex-col" }
const _hoisted_67 = {
  type: "button",
  class: "bg-[#8777FF] rounded-full px-8 py-2 text-base shadow-lg text-white mx-2 flex flex-row justify-center items-center flex-wrap w-full"
}
const _hoisted_68 = { class: "text-[#6A737F]" }
const _hoisted_69 = { class: "text-[#8777FF]" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1))
const _hoisted_71 = { class: "fixed inset-0 z-10 overflow-y-auto" }
const _hoisted_72 = { class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0" }
const _hoisted_73 = { class: "flex flex-col bg-white gap-3" }
const _hoisted_74 = { class: "flex flex-col items-center px-4 py-6" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18 6L6 18M6 6L18 18",
    stroke: "#98A2B3",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_76 = [
  _hoisted_75
]
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
      fill: "#DCFAE6"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M19.5 24L22.5 27L28.5 21M34 24C34 29.5228 29.5228 34 24 34C18.4772 34 14 29.5228 14 24C14 18.4772 18.4772 14 24 14C29.5228 14 34 18.4772 34 24Z",
      stroke: "#079455",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1))
const _hoisted_78 = { class: "mt-6 font-semibold text-2xl text-[#101828]" }
const _hoisted_79 = { class: "font-normal text-sm text-[#475467] text-center mt-2" }
const _hoisted_80 = { class: "font-normal text-sm text-[#D92D20] text-center mt-5" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1))
const _hoisted_82 = { class: "fixed inset-0 z-10 w-screen overflow-y-auto" }
const _hoisted_83 = { class: "flex min-h-full items-end justify-center p-8 text-center sm:items-center" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M13 1L1 13M1 1L13 13",
    stroke: "#98A2B3",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_85 = [
  _hoisted_84
]
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-auto flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
      fill: "#DCFAE6"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M34 33V31C34 29.1362 32.7252 27.5701 31 27.126M27.5 15.2908C28.9659 15.8841 30 17.3213 30 19C30 20.6787 28.9659 22.1159 27.5 22.7092M29 33C29 31.1362 29 30.2044 28.6955 29.4693C28.2895 28.4892 27.5108 27.7105 26.5307 27.3045C25.7956 27 24.8638 27 23 27H20C18.1362 27 17.2044 27 16.4693 27.3045C15.4892 27.7105 14.7105 28.4892 14.3045 29.4693C14 30.2044 14 31.1362 14 33M25.5 19C25.5 21.2091 23.7091 23 21.5 23C19.2909 23 17.5 21.2091 17.5 19C17.5 16.7909 19.2909 15 21.5 15C23.7091 15 25.5 16.7909 25.5 19Z",
      stroke: "#079455",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1))
const _hoisted_87 = { class: "mt-5 text-center" }
const _hoisted_88 = { class: "text-center" }
const _hoisted_89 = { class: "text-sm text-[#475467] mb-8" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_91 = { class: "mt-6 flex justify-around items-center flex-row" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1))
const _hoisted_93 = { class: "fixed inset-0 z-10 overflow-y-auto" }
const _hoisted_94 = { class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0" }
const _hoisted_95 = { class: "flex flex-col bg-white gap-3 py-4 px-2" }
const _hoisted_96 = { class: "absolute right-8 top-6" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M18 6L6 18M6 6L18 18",
  stroke: "#98A2B3",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_98 = [
  _hoisted_97
]
const _hoisted_99 = { class: "flex flex-col items-center gap-6 px-9" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
      fill: "#DCFAE6"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M19.5 24L22.5 27L28.5 21M34 24C34 29.5228 29.5228 34 24 34C18.4772 34 14 29.5228 14 24C14 18.4772 18.4772 14 24 14C29.5228 14 34 18.4772 34 24Z",
      stroke: "#079455",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1))
const _hoisted_101 = { class: "flex flex-col items-center text-center gap-2" }
const _hoisted_102 = { class: "font-semibold text-[#101828] text-lg" }
const _hoisted_103 = { class: "font-normal text-sm text-[#475467] w-[19rem]" }
const _hoisted_104 = { class: "flex flex-col gap-4 w-full" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1))
const _hoisted_106 = { class: "fixed inset-0 z-10 w-screen overflow-y-auto" }
const _hoisted_107 = { class: "flex min-h-full items-end justify-center p-8 text-center sm:items-center" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "13",
  height: "13",
  viewBox: "0 0 13 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.587 9.72511C10.7015 9.83959 10.7658 9.99486 10.7658 10.1568C10.7658 10.3187 10.7015 10.4739 10.587 10.5884C10.4725 10.7029 10.3173 10.7672 10.1554 10.7672C9.99346 10.7672 9.83819 10.7029 9.72371 10.5884L6.49961 7.36328L3.27449 10.5874C3.16002 10.7019 3.00475 10.7662 2.84285 10.7662C2.68096 10.7662 2.52569 10.7019 2.41121 10.5874C2.29674 10.4729 2.23242 10.3176 2.23242 10.1557C2.23242 9.99384 2.29674 9.83858 2.41121 9.7241L5.63633 6.5L2.41223 3.27488C2.29775 3.1604 2.23344 3.00514 2.23344 2.84324C2.23344 2.68134 2.29775 2.52608 2.41223 2.4116C2.52671 2.29712 2.68197 2.23281 2.84387 2.23281C3.00577 2.23281 3.16103 2.29712 3.27551 2.4116L6.49961 5.63672L9.72473 2.41109C9.83921 2.29661 9.99447 2.2323 10.1564 2.2323C10.3183 2.2323 10.4735 2.29661 10.588 2.41109C10.7025 2.52557 10.7668 2.68084 10.7668 2.84273C10.7668 3.00463 10.7025 3.15989 10.588 3.27437L7.36289 6.5L10.587 9.72511Z",
    fill: "#828284"
  })
], -1))
const _hoisted_109 = [
  _hoisted_108
]
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-auto flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "78",
    height: "77",
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      x: "0.9375",
      width: "76.125",
      height: "76.125",
      rx: "38.0625",
      fill: "#53DDC9",
      "fill-opacity": "0.25"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M59.9167 25H33.375C31.1292 25 29.2917 26.8375 29.2917 29.0833V47.4583C29.2917 48.5413 29.7219 49.5799 30.4876 50.3457C31.2534 51.1115 32.292 51.5417 33.375 51.5417H59.9167C62.1829 51.5417 64 49.7246 64 47.4583V29.0833C64 28.0004 63.5698 26.9618 62.804 26.196C62.0382 25.4302 60.9996 25 59.9167 25ZM59.9167 47.4583H33.375V32.4929L46.6458 39.2917L59.9167 32.4929V47.4583ZM46.6458 35.8413L33.375 29.0833H59.9167L46.6458 35.8413ZM25.2083 47.4583C25.2083 47.8054 25.2696 48.1321 25.3104 48.4792H17.0417C15.9147 48.4792 15 47.5604 15 46.4375C15 45.3146 15.9147 44.3958 17.0417 44.3958H25.2083V47.4583ZM21.125 28.0625H25.3104C25.2696 28.4096 25.2083 28.7362 25.2083 29.0833V32.1458H21.125C20.0021 32.1458 19.0833 31.2271 19.0833 30.1042C19.0833 28.9812 20.0021 28.0625 21.125 28.0625ZM17.0417 38.2708C17.0417 37.1479 17.9604 36.2292 19.0833 36.2292H25.2083V40.3125H19.0833C17.9604 40.3125 17.0417 39.3937 17.0417 38.2708Z",
      fill: "#53DDC9"
    })
  ])
], -1))
const _hoisted_111 = { class: "mt-6 text-center" }
const _hoisted_112 = { class: "text-center" }
const _hoisted_113 = { class: "text-sm text-[#475467]" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1))
const _hoisted_115 = { class: "fixed inset-0 z-10 w-screen overflow-y-auto" }
const _hoisted_116 = { class: "flex min-h-full items-end justify-center p-8 text-center sm:items-center" }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-auto flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "calendar-icon",
    width: "78",
    height: "77",
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      x: "0.9375",
      width: "76.125",
      height: "76.125",
      rx: "38.0625",
      fill: "#FDA29B",
      "fill-opacity": "0.25"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M22.5005 36.4279C22.5005 29.9073 22.5005 26.646 24.5271 24.6212C26.5519 22.5946 29.8131 22.5946 36.3338 22.5946H43.2505C49.7712 22.5946 53.0324 22.5946 55.0572 24.6212C57.0838 26.646 57.0838 29.9073 57.0838 36.4279V39.8863C57.0838 46.407 57.0838 49.6682 55.0572 51.693C53.0324 53.7196 49.7712 53.7196 43.2505 53.7196H36.3338C29.8131 53.7196 26.5519 53.7196 24.5271 51.693C22.5005 49.6682 22.5005 46.407 22.5005 39.8863V36.4279Z",
      stroke: "#FDA29B",
      "stroke-width": "2.59375"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M31.147 22.5946V20.0009M48.4386 22.5946V20.0009M23.3657 31.2404H56.2199",
      stroke: "#FDA29B",
      "stroke-width": "2.59375",
      "stroke-linecap": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M50.1665 45.0725C50.1665 45.5311 49.9843 45.9709 49.66 46.2952C49.3358 46.6195 48.8959 46.8016 48.4373 46.8016C47.9787 46.8016 47.5389 46.6195 47.2146 46.2952C46.8903 45.9709 46.7082 45.5311 46.7082 45.0725C46.7082 44.6139 46.8903 44.174 47.2146 43.8498C47.5389 43.5255 47.9787 43.3433 48.4373 43.3433C48.8959 43.3433 49.3358 43.5255 49.66 43.8498C49.9843 44.174 50.1665 44.6139 50.1665 45.0725ZM50.1665 38.1558C50.1665 38.6144 49.9843 39.0542 49.66 39.3785C49.3358 39.7028 48.8959 39.885 48.4373 39.885C47.9787 39.885 47.5389 39.7028 47.2146 39.3785C46.8903 39.0542 46.7082 38.6144 46.7082 38.1558C46.7082 37.6972 46.8903 37.2574 47.2146 36.9331C47.5389 36.6088 47.9787 36.4266 48.4373 36.4266C48.8959 36.4266 49.3358 36.6088 49.66 36.9331C49.9843 37.2574 50.1665 37.6972 50.1665 38.1558ZM41.5207 45.0725C41.5207 45.5311 41.3385 45.9709 41.0142 46.2952C40.6899 46.6195 40.2501 46.8016 39.7915 46.8016C39.3329 46.8016 38.8931 46.6195 38.5688 46.2952C38.2445 45.9709 38.0623 45.5311 38.0623 45.0725C38.0623 44.6139 38.2445 44.174 38.5688 43.8498C38.8931 43.5255 39.3329 43.3433 39.7915 43.3433C40.2501 43.3433 40.6899 43.5255 41.0142 43.8498C41.3385 44.174 41.5207 44.6139 41.5207 45.0725ZM41.5207 38.1558C41.5207 38.6144 41.3385 39.0542 41.0142 39.3785C40.6899 39.7028 40.2501 39.885 39.7915 39.885C39.3329 39.885 38.8931 39.7028 38.5688 39.3785C38.2445 39.0542 38.0623 38.6144 38.0623 38.1558C38.0623 37.6972 38.2445 37.2574 38.5688 36.9331C38.8931 36.6088 39.3329 36.4266 39.7915 36.4266C40.2501 36.4266 40.6899 36.6088 41.0142 36.9331C41.3385 37.2574 41.5207 37.6972 41.5207 38.1558ZM32.8748 45.0725C32.8748 45.5311 32.6927 45.9709 32.3684 46.2952C32.0441 46.6195 31.6043 46.8016 31.1457 46.8016C30.6871 46.8016 30.2472 46.6195 29.923 46.2952C29.5987 45.9709 29.4165 45.5311 29.4165 45.0725C29.4165 44.6139 29.5987 44.174 29.923 43.8498C30.2472 43.5255 30.6871 43.3433 31.1457 43.3433C31.6043 43.3433 32.0441 43.5255 32.3684 43.8498C32.6927 44.174 32.8748 44.6139 32.8748 45.0725ZM32.8748 38.1558C32.8748 38.6144 32.6927 39.0542 32.3684 39.3785C32.0441 39.7028 31.6043 39.885 31.1457 39.885C30.6871 39.885 30.2472 39.7028 29.923 39.3785C29.5987 39.0542 29.4165 38.6144 29.4165 38.1558C29.4165 37.6972 29.5987 37.2574 29.923 36.9331C30.2472 36.6088 30.6871 36.4266 31.1457 36.4266C31.6043 36.4266 32.0441 36.6088 32.3684 36.9331C32.6927 37.2574 32.8748 37.6972 32.8748 38.1558Z",
      fill: "#FDA29B"
    })
  ])
], -1))
const _hoisted_118 = { class: "mt-6 text-center" }
const _hoisted_119 = { key: 0 }
const _hoisted_120 = { key: 1 }
const _hoisted_121 = { class: "mt-6 text-center" }
const _hoisted_122 = { class: "text-sm text-[#475467]" }
const _hoisted_123 = { key: 0 }
const _hoisted_124 = { class: "text-center" }
const _hoisted_125 = { class: "mt-6 flex justify-around items-center gap-3" }
const _hoisted_126 = { class: "text-center mt-2" }
const _hoisted_127 = { class: "text-sm text-[#475467]" }

import { onMounted, ref, onBeforeMount, reactive, watch } from "vue";
import { useRouter } from "vue-router";
import { useSchoolStore } from "@/stores/schoolStore";
import { useLearnerStore } from "@/stores/learnerStore";
import AddGradesClassesComponent from "../components/AddGradesClassesComponent.vue";
import TeacherDetails from "@/modules/main/components/TeacherDetailsComponent.vue";
import { useRolloverStore } from "@/stores/rolloverStore";
import { Rollover } from "@/interfaces/rollover.interface";
import { School } from "@/interfaces/school.interface";
import { Admin } from "@/interfaces/admin.interface";
import ArchiveUnarchiveComponent from "@/modules/main/components/internal-tools/InternalArchiveContentComponent.vue";
import AdminOverviewComponent from "@/modules/main/components/AdminOverviewComponent.vue";
import GradesClassesDetailsComponent from "../components/GradesClassesDetailsComponent.vue";
import RolloverAlertComponent from "../components/RolloverAlertComponent.vue";
import PageHeaderComponent from "@/components/global/PageHeaderComponent.vue";

//variables

export default /*#__PURE__*/_defineComponent({
  __name: 'AdminView',
  setup(__props) {

const hideSection = ref(true);
const uploadedLearners = ref<any>([]);
const showLearnersBulkUploadProgressModal = ref(false);
const showModal = ref(false);
const showRollover = ref(false);
const completeRolloverModal = ref(false);
const confirmRolloverDateModal = ref(false);
const newRolloverDate = ref("");
const rolloverDate = ref("2024-01-01");
const isCalendarHidden = ref(false);
const isActive = ref<string>("");
const showSendDetails = ref(false);
const step = ref(0);
const loading = ref(false);
const isActiveSchoolDetails = ref(true);
const errorMessage = ref(false);
const uploadPreviewCard = ref(false);
const goToAssignModal = ref(false);
const completeClassReviewModal = ref(false);
const currentOpenGrade = ref(null);
const checkboxChecked: { [key: string]: boolean } = reactive({});
const selectedGrade = ref(null);
let initialSchoolChampions = ref<Admin[]>([]);
let schoolChampions = ref<Admin[]>([]);

const router = useRouter();
const rolloverStore = useRolloverStore();

// stores
const schoolStore = useSchoolStore();
const learnerStore = useLearnerStore();

const confirmRolloverComplete = async () => {
  const currentRollOver = rolloverStore.rollover as Rollover;

  if (currentRollOver) {
    currentRollOver.isComplete = true;
    await rolloverStore.updateRolloverObject(currentRollOver);
  }

  router.push("/main/internal");
};

const schoolObject = ref<School>({
  _id: "",
  classGroups: [] as string[],
  gradeLevels: [] as number[],
  name: "",
  code: "",
  description: "",
  language: "",
  domain: "",
  status: "",
  emisNumber: "",
  isPartOfGroup: false,
  schoolGroup: "",
  gradeNamingConvention: "",
  schoolLicense: "",
  academicYearStart: "",
  academicYearEnd: "",
  preferredLang: "",
  location: {
    city: "",
    country: "",
    street: "",
  },
  classGroupActions: {
    newClasses: [],
    removedClasses: [],
    teachersAssignment: [],
  },
});

// Store initial values for comparison
const initialSchoolObject = ref({
  _id: "",
  classGroups: [],
  gradeLevels: [],
  name: "",
  code: "",
  domain: "",
  description: "",
  status: "",
  emisNumber: "",
  isPartOfGroup: false,
  schoolGroup: "",
  gradeNamingConvention: "",
  schoolLicense: "",
  academicYearStart: "",
  academicYearEnd: "",
  preferredLang: "",
  location: {
    city: "",
    country: "",
    street: "",
  },
  classGroupActions: {
    newClasses: [],
    removedClasses: [],
    teachersAssignment: [],
  },
});

// Fetch the initial country from the store and set `selectedOption` if it matches an option
onBeforeMount(async () => {
  //calling locales endpoint
  await schoolStore.fetchLocales();
  await updateSchoolDetails();
});

const confirmDates = async () => {
  confirmRolloverDateModal.value = false;

  if (newRolloverDate.value) {
    rolloverDate.value = newRolloverDate.value;

    const currentRollOver = rolloverStore.rollover as Rollover;

    currentRollOver.status.learnerRollover = "in_review";
    currentRollOver.rolloverDate = new Date(
      newRolloverDate.value
    ).toISOString();
    await rolloverStore.updateRolloverObject(currentRollOver);

    router.push("/main/incomplete-rollover");
  } else if (rolloverDate.value) {
    const currentRollOver = rolloverStore.rollover as Rollover;
    currentRollOver.status.learnerRollover = "in_review";

    await rolloverStore.updateRolloverObject(currentRollOver);
    router.push("/main/incomplete-rollover");
  } else {
    router.push("/main/incomplete-rollover");
  }
};

const updateSchoolDetails = async () => {
  const currentSchool = schoolStore.getCurrentSchool;
  if (currentSchool) {
    schoolObject.value = { ...schoolStore.currentSchool };
    initialSchoolObject.value = JSON.parse(
      JSON.stringify(schoolStore.currentSchool)
    );

    // Assign all school admins to `schoolChampions`
    if (schoolStore.currentSchoolStructure?.schoolAdmins) {
      schoolChampions.value =
        schoolStore.currentSchoolStructure.schoolAdmins.map((admin) => ({
          ...admin,
        }));
      initialSchoolChampions.value = JSON.parse(
        JSON.stringify(schoolStore.currentSchoolStructure.schoolAdmins)
      );
    }

    await rolloverStore.fetchSchoolRollover(currentSchool._id);

    if (rolloverStore.rollover?.rolloverDate) {
      const date = new Date(rolloverStore.rollover?.rolloverDate);

      // date in format YYYY-MM-DD
      rolloverDate.value = date.toISOString().split('T')[0];
    }

    if (
      rolloverStore.rollover &&
      rolloverStore.rollover?.school === schoolStore.currentSchool?._id &&
      rolloverStore.rollover?.isComplete !== true
      ) {
        showRollover.value = true;
    }
  }
};

onMounted(() => {
  isActive.value = "overview";
});

const setActive = (section: string) => {
  isActive.value = section;
};

// Watch for changes in gradeLevels
watch(
  () => schoolStore.currentSchoolStructure?.gradeLevels,
  (newVal, oldVal) => {
    if (newVal !== oldVal) {
      // Trigger the modal when gradeLevels change
      showSendDetails.value = schoolStore?.enableSentModal;

      //clear the state
      //reset step back to zero
      schoolStore.step = 0;
      //clear the selected grades
      schoolStore.SelectedGrades = [];

      //clear teachers array in the state
      if (schoolStore.initialSchoolStructure) {
        schoolStore.initialSchoolStructure.teachers = [];
      }

      //clear classGroups array in the state
      if (schoolStore.initialSchoolStructure) {
        schoolStore.initialSchoolStructure.classGroups = [];
      }
    }
  }
);

const submitLearnersForUpload = async () => {
  loading.value = true;
  try {
    let request = await learnerStore.bulkCreateLearners(uploadedLearners.value);
    showLearnersBulkUploadProgressModal.value = true;
    console.log("Request: ", request);
    loading.value = false;
  } catch (error) {
    console.error(error);
    errorMessage.value = false;
  }
};

const closeSuccessFailModal = () => {
  errorMessage.value = false;
};

const uploadInProgress = () => {
  showLearnersBulkUploadProgressModal.value = false;
  hideSection.value = false;
  uploadedLearners.value = [];
};

const clearLearners = () => {
  uploadedLearners.value = [];
  hideSection.value = false;
};

// Confirm the selection in the modal
const confirmSelection = (grade: any) => {
  checkboxChecked[grade] = true; // Keep the checkbox checked
  currentOpenGrade.value = grade; // Open the grade section
  showModal.value = false; // Close the modal
};

// Cancel the selection and uncheck the checkbox
const cancelSelection = (grade: any) => {
  currentOpenGrade.value = null; // Close the grade section
  checkboxChecked[grade] = false; // Uncheck the checkbox if modal is cancelled
  showModal.value = false; // Close the modal
};

const confirmClassReview = async () => {
  const currentRollOver = rolloverStore.rollover as Rollover;

  if (currentRollOver) {
    currentRollOver.status.classReview = "pending_job_run";
    await rolloverStore.updateRolloverObject(currentRollOver);
  }

  // completeClassReviewModal.value = false;
  router.push("/main/internal");
};
// student bulk upload END

return (_ctx: any,_cache: any) => {
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_DialogTitle = _resolveComponent("DialogTitle")!
  const _component_DialogPanel = _resolveComponent("DialogPanel")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PageHeaderComponent, {
      pageHeading: _ctx.$t('admin_screens.main_title')
    }, null, 8, ["pageHeading"]),
    (
      _unref(schoolStore).currentSchoolStructure &&
      _unref(schoolStore).currentSchoolStructure?.gradeLevels.length < 1
    )
      ? (_openBlock(), _createBlock(AddGradesClassesComponent, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (showRollover.value && _unref(rolloverStore).loader.rollover != true)
            ? (_openBlock(), _createBlock(RolloverAlertComponent, {
                key: 0,
                class: "mt-6",
                rollover: (_unref(rolloverStore).rollover as Rollover),
                onCompleteRolloverModal: _cache[0] || (_cache[0] = ($event: any) => (completeRolloverModal.value = $event)),
                onConfirmRolloverDateModal: _cache[1] || (_cache[1] = ($event: any) => (confirmRolloverDateModal.value = $event))
              }, null, 8, ["rollover"]))
            : _createCommentVNode("", true),
          (step.value == 0)
            ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["py-2 px-8 flex items-center gap-1 font-medium", {
            'active-class': isActive.value === 'overview',
            'inactive-class': isActive.value !== 'overview',
          }]),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (setActive('overview')))
                  }, _toDisplayString(_ctx.$t("admin_screens.bulk_upload_students.overview")), 3),
                  _createElementVNode("button", {
                    class: _normalizeClass(["py-2 px-8 flex items-center gap-1 font-medium", {
            'active-class': isActive.value === 'school',
            'inactive-class': isActive.value !== 'school',
          }]),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (setActive('school')))
                  }, _toDisplayString(_ctx.$t("admin_screens.bulk_upload_students.school_details")), 3),
                  _createElementVNode("button", {
                    class: _normalizeClass(["py-2 px-8 flex items-center gap-1 font-medium", {
            'active-class': isActive.value === 'archive & unarchive',
            'inactive-class': isActive.value !== 'archive & unarchive',
          }]),
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (setActive('archive & unarchive')))
                  }, " Archive & Unarchive ", 2)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            (isActive.value === 'overview')
              ? (_openBlock(), _createBlock(AdminOverviewComponent, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          (isActive.value === 'school' && uploadPreviewCard.value === false)
            ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["py-2 px-3 rounded-full text-sm font-semibold", { 'active-school-detail': isActiveSchoolDetails.value }]),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (isActiveSchoolDetails.value = true))
                  }, _toDisplayString(_ctx.$t("admin_screens.grade_and_classes")), 3),
                  _createElementVNode("button", {
                    class: _normalizeClass(["py-2 px-3 rounded-full text-sm font-semibold", { 'active-school-detail': !isActiveSchoolDetails.value }]),
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (isActiveSchoolDetails.value = false))
                  }, _toDisplayString(_ctx.$t("admin_screens.teacher_details")), 3)
                ]),
                (isActiveSchoolDetails.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(GradesClassesDetailsComponent)
                    ]))
                  : _createCommentVNode("", true),
                (!isActiveSchoolDetails.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(TeacherDetails)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (isActive.value === 'school' && uploadPreviewCard.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.$t("archive_flow.upload_preview_header")), 1),
                  _createElementVNode("table", _hoisted_11, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", _hoisted_12, [
                        _hoisted_13,
                        _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t("archive_flow.learners_table.email")), 1),
                        _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t("archive_flow.learners_table.first_name")), 1),
                        _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t("archive_flow.learners_table.last_name")), 1),
                        _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t("admin_screens.bulk_upload_students.student_number")), 1),
                        _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t("admin_screens.bulk_upload_students.password")), 1),
                        _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.$t("admin_screens.bulk_upload_students.class_group")), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uploadedLearners.value, (learner, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: index,
                          class: "mb-1"
                        }, [
                          _hoisted_20,
                          _createElementVNode("td", _hoisted_21, _toDisplayString(learner.email), 1),
                          _createElementVNode("td", _hoisted_22, _toDisplayString(learner.firstName), 1),
                          _createElementVNode("td", _hoisted_23, _toDisplayString(learner.lastName), 1),
                          _createElementVNode("td", _hoisted_24, _toDisplayString(learner.studentNumber), 1),
                          _createElementVNode("td", _hoisted_25, _toDisplayString(learner.password), 1),
                          _createElementVNode("td", _hoisted_26, _toDisplayString(learner.classGroup), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("button", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (uploadPreviewCard.value = false && isActive.value === 'school')),
                    class: "font-semibold text-[#344054] text-base border-[#D0D5DD] border rounded-lg ms-10 py-2 px-4 flex items-center shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] bg-white"
                  }, [
                    _hoisted_28,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("admin_screens.bulk_upload_students.back")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("button", {
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (uploadPreviewCard.value = false && clearLearners)),
                      class: "font-semibold text-[#344054] text-base border-[#D0D5DD] border rounded-lg py-2 px-4 font-medium flex items-center bg-transparent me-4 shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] bg-white"
                    }, _toDisplayString(_ctx.$t("admin_screens.bulk_upload_students.cancel")), 1),
                    _createElementVNode("button", {
                      onClick: submitLearnersForUpload,
                      class: "rounded-lg py-2 px-4 text-white flex items-center font-semibold bg-[#155EEF] shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)]"
                    }, [
                      (loading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("admin_screens.bulk_upload_students.submit")), 1)
                    ])
                  ])
                ]),
                (errorMessage.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _createVNode(_component_TransitionRoot, {
                        as: "template",
                        show: true
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Dialog, {
                            as: "div",
                            class: "relative z-40"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_TransitionChild, {
                                as: "template",
                                enter: "ease-out duration-300",
                                "enter-from": "opacity-0",
                                "enter-to": "opacity-100",
                                leave: "ease-in duration-200",
                                "leave-from": "opacity-100",
                                "leave-to": "opacity-0"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_32
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("div", _hoisted_34, [
                                  _createVNode(_component_TransitionChild, {
                                    as: "template",
                                    enter: "ease-out duration-300",
                                    "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                                    "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                                    leave: "ease-in duration-200",
                                    "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                                    "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_DialogPanel, { class: "p-8 relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md" }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", null, [
                                            _createElementVNode("div", {
                                              class: "absolute top-6 right-4 cursor-pointer",
                                              onClick: closeSuccessFailModal
                                            }, _hoisted_36),
                                            _hoisted_37,
                                            _createElementVNode("div", _hoisted_38, [
                                              _createVNode(_component_DialogTitle, {
                                                as: "h3",
                                                class: "mt-6 font-semibold text-2xl text-[#101828]"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.modals.incomplete")), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _createElementVNode("div", _hoisted_39, [
                                              _createElementVNode("p", null, _toDisplayString(_ctx.$t("archive_flow.modals.error_message")), 1)
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_40, [
                                            _createElementVNode("button", {
                                              onClick: closeSuccessFailModal,
                                              type: "button",
                                              class: "font-semibold text-[#344054] text-base border-[#D0D5DD] border rounded-lg py-2 px-8 mt-8 w-full"
                                            }, _toDisplayString(_ctx.$t("archive_flow.modals.close")), 1)
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (isActive.value === 'archive & unarchive')
            ? (_openBlock(), _createElementBlock("section", _hoisted_41, [
                _createVNode(ArchiveUnarchiveComponent)
              ]))
            : _createCommentVNode("", true)
        ])),
    _createVNode(_component_TransitionRoot, {
      as: "template",
      show: completeClassReviewModal.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Dialog, {
          as: "div",
          class: "relative z-40",
          onClose: _cache[11] || (_cache[11] = ($event: any) => (completeClassReviewModal.value = false))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TransitionChild, {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _hoisted_42
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _createVNode(_component_TransitionChild, {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DialogPanel, { class: "p-8 relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createElementVNode("button", {
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (completeClassReviewModal.value = false)),
                            class: "absolute top-4 right-4"
                          }, _hoisted_46),
                          _hoisted_47,
                          _createElementVNode("div", _hoisted_48, [
                            _createVNode(_component_DialogTitle, {
                              as: "h3",
                              class: "text-2xl font-semibold leading-6 text-[#4B5563]"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t(
                        "admin_view.modals.complete_class_review.class_structure"
                      )), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_49, [
                            _createElementVNode("p", _hoisted_50, _toDisplayString(_ctx.$t("admin_view.modals.complete_class_review.final_step")), 1),
                            _createElementVNode("p", _hoisted_51, _toDisplayString(_ctx.$t(
                        "admin_view.modals.complete_class_review.soon_get_emails"
                      )), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("button", {
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (confirmClassReview())),
                            type: "button",
                            class: "bg-[#8777FF] rounded-full px-8 py-2 text-base shadow-lg text-white mx-2 flex flex-row justify-center items-center flex-wrap w-full"
                          }, _toDisplayString(_ctx.$t("admin_view.modals.complete_class_review.btn_confirm")), 1),
                          _createVNode(_component_router_link, { to: "/main/internal" }, {
                            default: _withCtx(() => [
                              _createElementVNode("button", _hoisted_53, [
                                _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.$t("admin_view.modals.complete_class_review.not_ready")), 1),
                                _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.$t("admin_view.modals.complete_class_review.come_back")), 1)
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_TransitionRoot, {
      as: "template",
      show: goToAssignModal.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Dialog, {
          as: "div",
          class: "relative z-40",
          onClose: _cache[14] || (_cache[14] = ($event: any) => (goToAssignModal.value = false))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TransitionChild, {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _hoisted_56
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                _createVNode(_component_TransitionChild, {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DialogPanel, { class: "p-8 relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createElementVNode("button", {
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (goToAssignModal.value = false)),
                            class: "absolute top-4 right-4"
                          }, _hoisted_60),
                          _hoisted_61,
                          _createElementVNode("div", _hoisted_62, [
                            _createVNode(_component_DialogTitle, {
                              as: "h3",
                              class: "text-2xl font-semibold leading-6 text-[#4B5563]"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("admin_view.modals.goto_assign.almost")), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_63, [
                            _createElementVNode("p", _hoisted_64, _toDisplayString(_ctx.$t("admin_view.modals.goto_assign.final_step")), 1),
                            _createElementVNode("p", _hoisted_65, _toDisplayString(_ctx.$t("admin_view.modals.goto_assign.number_students")), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_66, [
                          _createVNode(_component_router_link, { to: "/main/add-student" }, {
                            default: _withCtx(() => [
                              _createElementVNode("button", _hoisted_67, _toDisplayString(_ctx.$t("admin_view.modals.goto_assign.assign")), 1)
                            ]),
                            _: 1
                          }),
                          _createElementVNode("button", {
                            type: "button",
                            class: "px-8 py-2 text-base mt-3 flex flex-row justify-evenly items-center flex-wrap w-full",
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (goToAssignModal.value = false))
                          }, [
                            _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.$t("admin_view.modals.goto_assign.not_ready")), 1),
                            _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.$t("admin_view.modals.goto_assign.come_back")), 1)
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_TransitionRoot, {
      as: "template",
      show: showLearnersBulkUploadProgressModal.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Dialog, {
          as: "div",
          class: "relative z-10"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TransitionChild, {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _hoisted_70
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("div", _hoisted_72, [
                _createVNode(_component_TransitionChild, {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DialogPanel, { class: "relative transform overflow-hidden rounded-2xl bg-white text-left shadow-xl transition-all sm:my-8" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_73, [
                          _createElementVNode("div", _hoisted_74, [
                            _createElementVNode("div", {
                              class: "absolute top-6 right-4 cursor-pointer",
                              onClick: uploadInProgress
                            }, _hoisted_76),
                            _hoisted_77,
                            _createElementVNode("h1", _hoisted_78, _toDisplayString(_ctx.$t("admin_screens.modals.almost")), 1),
                            _createElementVNode("p", _hoisted_79, _toDisplayString(_ctx.$t("admin_screens.modals.check_email_text")), 1),
                            _createElementVNode("p", _hoisted_80, _toDisplayString(_ctx.$t("admin_screens.modals.note_text")), 1),
                            _createElementVNode("button", {
                              onClick: uploadInProgress,
                              class: "font-semibold text-[#344054] text-base border-[#D0D5DD] border rounded-lg py-2 px-8 mt-8 w-full"
                            }, _toDisplayString(_ctx.$t("archive_flow.done")), 1)
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]),
    (showModal.value)
      ? (_openBlock(), _createBlock(_component_TransitionRoot, {
          key: 2,
          as: "template",
          show: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Dialog, {
              as: "div",
              class: "relative z-40",
              onClose: _cache[18] || (_cache[18] = ($event: any) => (goToAssignModal.value = false))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_TransitionChild, {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0",
                  "enter-to": "opacity-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100",
                  "leave-to": "opacity-0"
                }, {
                  default: _withCtx(() => [
                    _hoisted_81
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_82, [
                  _createElementVNode("div", _hoisted_83, [
                    _createVNode(_component_TransitionChild, {
                      as: "template",
                      enter: "ease-out duration-300",
                      "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                      "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                      leave: "ease-in duration-200",
                      "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                      "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DialogPanel, { class: "p-8 relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createElementVNode("button", {
                                onClick: _cache[15] || (_cache[15] = ($event: any) => (cancelSelection(selectedGrade.value))),
                                class: "absolute top-4 right-4"
                              }, _hoisted_85),
                              _hoisted_86,
                              _createElementVNode("div", _hoisted_87, [
                                _createVNode(_component_DialogTitle, {
                                  as: "h3",
                                  class: "text-lg font-semibold text-[##101828] mb-1"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("admin_screens.modals.add_new_grade_header")) + "!", 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_88, [
                                _createElementVNode("p", _hoisted_89, [
                                  _createTextVNode(_toDisplayString(_ctx.$t("admin_screens.modals.are_you_sure")) + " [grade]", 1),
                                  _hoisted_90,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t("admin_screens.modals.to_the_program")) + "? ", 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_91, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "text-[#344054] border border-[#D0D5DD] text-sm font-semibold px-4 py-2.5 bg-white rounded-lg mr-3 items-center flex-wrap w-full",
                                onClick: _cache[16] || (_cache[16] = ($event: any) => (cancelSelection(selectedGrade.value)))
                              }, _toDisplayString(_ctx.$t("admin_screens.modals.cancel")), 1),
                              _createElementVNode("button", {
                                type: "button",
                                class: "text-white border border-[#155EEF] bg-[#155EEF] text-sm font-semibold px-4 py-2.5 rounded-lg items-center flex-wrap w-full",
                                onClick: _cache[17] || (_cache[17] = ($event: any) => (confirmSelection(selectedGrade.value)))
                              }, _toDisplayString(_ctx.$t("admin_screens.modals.im_sure")), 1)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_TransitionRoot, {
      as: "template",
      show: showSendDetails.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Dialog, {
          as: "div",
          class: "relative z-10"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TransitionChild, {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _hoisted_92
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_93, [
              _createElementVNode("div", _hoisted_94, [
                _createVNode(_component_TransitionChild, {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DialogPanel, { class: "relative transform overflow-hidden rounded-[12px] bg-white text-left shadow-xl transition-all sm:my-8 py-3 pt-4 px-1" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_95, [
                          _createElementVNode("div", _hoisted_96, [
                            (_openBlock(), _createElementBlock("svg", {
                              onClick: _cache[19] || (_cache[19] = ($event: any) => (showSendDetails.value = false)),
                              class: "cursor-pointer",
                              width: "24",
                              height: "24",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }, _hoisted_98))
                          ]),
                          _createElementVNode("div", _hoisted_99, [
                            _hoisted_100,
                            _createElementVNode("div", _hoisted_101, [
                              _createElementVNode("h1", _hoisted_102, _toDisplayString(_ctx.$t("add_grades_class_component.step_4.success")), 1),
                              _createElementVNode("p", _hoisted_103, _toDisplayString(_ctx.$t("add_grades_class_component.step_4.success_message")), 1)
                            ]),
                            _createElementVNode("div", _hoisted_104, [
                              _createElementVNode("button", {
                                class: "rounded-lg py-2 px-6 text-white w-full font-semibold bg-[#155EEF]",
                                onClick: _cache[20] || (_cache[20] = ($event: any) => (
                        (showSendDetails.value = false),
                          (_unref(schoolStore).enableSentModal = false)
                      ))
                              }, _toDisplayString(_ctx.$t("add_grades_class_component.step_4.btn_view")), 1)
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_TransitionRoot, {
      appear: "",
      as: "template",
      show: completeRolloverModal.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Dialog, {
          as: "div",
          class: "relative z-40",
          onClose: _cache[23] || (_cache[23] = ($event: any) => (completeRolloverModal.value = false))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TransitionChild, {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _hoisted_105
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_106, [
              _createElementVNode("div", _hoisted_107, [
                _createVNode(_component_TransitionChild, {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DialogPanel, { class: "p-8 relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createElementVNode("button", {
                            onClick: _cache[21] || (_cache[21] = ($event: any) => (completeRolloverModal.value = false)),
                            class: "absolute top-4 right-4 focus-within:outline-none"
                          }, _hoisted_109),
                          _hoisted_110,
                          _createElementVNode("div", _hoisted_111, [
                            _createVNode(_component_DialogTitle, {
                              as: "h3",
                              class: "text-lg font-semibold leading-6 text-[#101828]"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("rollover.modal.success.title")), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_112, [
                            _createElementVNode("p", _hoisted_113, _toDisplayString(_ctx.$t("rollover.modal.success.text")), 1)
                          ]),
                          _createElementVNode("button", {
                            onClick: _cache[22] || (_cache[22] = ($event: any) => (confirmRolloverComplete())),
                            type: "button",
                            class: "bg-[#155EEF] rounded-lg p-2.5 text-base shadow-lg text-white mt-6 flex flex-row justify-center items-center flex-wrap mx-auto"
                          }, _toDisplayString(_ctx.$t("rollover.modal.success.confirm")), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_TransitionRoot, {
      appear: "",
      as: "template",
      show: confirmRolloverDateModal.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Dialog, {
          as: "div",
          class: "relative z-40",
          onClose: _cache[30] || (_cache[30] = ($event: any) => (confirmRolloverDateModal.value = false))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TransitionChild, {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _hoisted_114
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_115, [
              _createElementVNode("div", _hoisted_116, [
                _createVNode(_component_TransitionChild, {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DialogPanel, { class: "p-8 relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _hoisted_117,
                          _createElementVNode("div", _hoisted_118, [
                            _createVNode(_component_DialogTitle, {
                              as: "h3",
                              class: "text-lg font-semibold leading-6 text-[#101828]"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("rollover.modal.confirm_date.title")) + " " + _toDisplayString(_ctx.$t("global.grade_naming_convention")) + " " + _toDisplayString(_ctx.$t("rollover.modal.confirm_date.starting")) + " ", 1),
                                (newRolloverDate.value)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_119, _toDisplayString(newRolloverDate.value), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_120, _toDisplayString(rolloverDate.value), 1)),
                                _createTextVNode(". ")
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_121, [
                            _createElementVNode("p", _hoisted_122, _toDisplayString(_ctx.$t("rollover.modal.confirm_date.text")) + ". ", 1)
                          ])
                        ]),
                        (isCalendarHidden.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                              _createElementVNode("pre", _hoisted_124, _toDisplayString(_unref(rolloverStore).rollover?.rolloverDate) + " ", 1),
                              _createVNode(_component_FormKit, {
                                type: "form",
                                actions: false
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_FormKit, {
                                    type: "date",
                                    label: "Select new date",
                                    "label-class": "text-[#344054] font-medium text-sm mb-1.5",
                                    "outer-class": "primary-select label-bold mt-6",
                                    modelValue: newRolloverDate.value,
                                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((newRolloverDate).value = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_125, [
                          (!isCalendarHidden.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "whitespace-nowrap rounded-lg w-full font-medium py-2 px-6 btn-outline-red text-[#FDA29B] border border-[#FDA29B]",
                                onClick: _cache[25] || (_cache[25] = ($event: any) => (isCalendarHidden.value = true))
                              }, _toDisplayString(_ctx.$t("rollover.modal.confirm_date.change")), 1))
                            : _createCommentVNode("", true),
                          (!isCalendarHidden.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                onClick: _cache[26] || (_cache[26] = ($event: any) => (confirmDates())),
                                type: "button",
                                class: "whitespace-nowrap rounded-lg w-full font-medium py-2 px-6 btn-red bg-[#FDA29B] text-white"
                              }, _toDisplayString(_ctx.$t("rollover.modal.confirm_date.date_correct")), 1))
                            : _createCommentVNode("", true),
                          (isCalendarHidden.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 2,
                                type: "button",
                                class: "whitespace-nowrap font-medium py-2 px-6 btn-outline-red text-[#FDA29B] border border-[#FDA29B]",
                                onClick: _cache[27] || (_cache[27] = ($event: any) => (isCalendarHidden.value = false))
                              }, _toDisplayString(_ctx.$t("rollover.modal.confirm_date.cancel")), 1))
                            : _createCommentVNode("", true),
                          (isCalendarHidden.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 3,
                                onClick: _cache[28] || (_cache[28] = ($event: any) => (confirmDates())),
                                type: "button",
                                class: "whitespace-nowrap font-medium py-2 px-6 btn-red bg-[#FDA29B] text-white"
                              }, _toDisplayString(_ctx.$t("rollover.modal.confirm_date.confirm_dates")), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_126, [
                          _createElementVNode("p", _hoisted_127, [
                            _createTextVNode(_toDisplayString(_ctx.$t("rollover.modal.confirm_date.not_ready")) + "? ", 1),
                            _createElementVNode("span", {
                              class: "text-[#FDA29B]",
                              onClick: _cache[29] || (_cache[29] = ($event: any) => (confirmRolloverDateModal.value = false))
                            }, _toDisplayString(_ctx.$t("rollover.modal.confirm_date.confirm_later")), 1)
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})